import { AsyncActionsScenario } from "onearm";
import { BIG_WIN_MULTIPLIER } from "../configs/slotDefinition.config.js";

export async function presentation(scope, ctx, spinData) {
    const { hud, scenes, gameLogic } = ctx;
    const { result, quickStop } = spinData;

    hud.setPresentationState();

    const actions = ctx.makePresentation(result, { quickStop });
    const scenario = new AsyncActionsScenario({ actions });

    scope.on(hud.onStop, () => scenario.skipAllIfPossible());

    scenario.start();

    await new Promise((resolve) => {
        scenario.onComplete.connect(resolve);
    });

    if (result.win >= gameLogic.bet * BIG_WIN_MULTIPLIER) {
        const popup = scenes.add("WinPopupScene");
        await scenes.show("WinPopupScene");
        await popup.showWin({ value: result.win });
        scenes.remove("WinPopupScene");
    }
}
